import Welcome from "../components/Welcome"

const Home = () => {
  return (
    <>
      <Welcome></Welcome>
    </>
  );
};

export default Home;
